import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import appStoreImg from '../../assets/images/app-store.png';
import googlePlayImg from '../../assets/images/google-play.png';
import { mobileAppLinksSelector } from '../../helpers/selectors';

const STORE_BADGES = {
  appStoreLink: {
    img: appStoreImg,
    alt: 'App Store'
  },
  playStoreLink: {
    img: googlePlayImg,
    alt: 'Google Play'
  }
};

class MobileAppSelectorPopup extends Component {
  renderStoreLinks() {
    const { mobileAppLinks } = this.props;

    return (
      <div className="text-center store-links mt-40 mb-35">
        {Object.entries(STORE_BADGES).map(([linkName, { img, alt }]) => {
          const storeLink = mobileAppLinks[linkName];

          return (
            storeLink && (
              <a key={linkName} href={storeLink} target="_blank" rel="noreferrer">
                <img src={img} alt={alt} className="m-5 va-top" />
              </a>
            )
          );
        })}
      </div>
    );
  }

  render() {
    const hasStoreLinks = Object.values(this.props.mobileAppLinks).some(Boolean);

    if (!hasStoreLinks) {
      return (
        <div className="mobile-app-selector-popup">
          <div className="text-center f-25 mt-40 mb-10">
            <FormattedMessage id="no_apps_available" />
          </div>
        </div>
      );
    }

    return (
      <div className="mobile-app-selector-popup">{this.renderStoreLinks()}</div>
    );
  }
}

function mapStateToProps(state) {
  return {
    mobileAppLinks: mobileAppLinksSelector(state)
  };
}

export default connect(mapStateToProps)(MobileAppSelectorPopup);
